import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const BlogEntry = (props) => {
  const { entryData, setDetailEntryData } = props;
  return (
    <FlexContainer className={'flex-column width100'} onClick={() => setDetailEntryData(entryData)}>
      <FlexContainer className={'width100 bgBlue400 height-220px'}>
        <img
          src={entryData?.entryImage}
          alt="Foto 1"
          style={{ width: '100%', height: '220px' }}
          className={''}
        />
      </FlexContainer>
      <FlexContainer className={'flex-column width100 height-220px'}>
        <Label className="text-12 margtb14">{entryData?.entryRegDate}</Label>
        <Label className="text-18 margb40 margt10 bold">
          <strong>{entryData?.entryTitle}</strong>
        </Label>
        <Label className="text-16 margb20">{entryData?.entryDescription}</Label>
      </FlexContainer>
    </FlexContainer>
  );
};

const EntriesRow = (props) => {
  const { entriesData, setDetailEntryData } = props;
  return (
    <FlexContainer className={'flex-column margtb30 m-margtb20'}>
      <FlexContainer className={'m-flex-column padlr20 m-padlr0 gap-10'}>
        {entriesData.map((entry, index) => (
          <BlogEntry key={index} entryData={entry} setDetailEntryData={setDetailEntryData} />
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

const BlogModule = (props) => {
  const { customTitle } = props;
  const setDetailEntryData = (entryData) => {};
/*
  const spacesCatEntriesData = [
    {
      entryTitle: 'Beneficios de trabajar en espacios de coworking',
      entryDescription:
        'Descubre cómo los espacios de coworking fomentan la creatividad, la colaboración y aumentan la productividad en entornos flexibles.',
      entryImage: 'spaces/slider1.jpg',
      entryRegDate: '15.06.24',
      longDescription: `
        <p>Los espacios de coworking han revolucionado la manera en la que profesionales independientes, startups y empresas consolidadas trabajan día a día. A través de un entorno compartido, se promueve la <strong>colaboración</strong> y se eliminan las distracciones propias del trabajo en casa.</p>
        <p>Entre los principales beneficios de trabajar en un coworking se encuentran:</p>
        <ul>
          <li><strong>Networking:</strong> Al interactuar con otros profesionales, se generan conexiones valiosas para futuros proyectos y oportunidades laborales.</li>
          <li><strong>Flexibilidad:</strong> Los coworkings ofrecen horarios adaptados a las necesidades del trabajador moderno, permitiendo mayor libertad.</li>
          <li><strong>Entorno Inspirador:</strong> Estas instalaciones están diseñadas para estimular la creatividad y productividad.</li>
          <li><strong>Costos Accesibles:</strong> A comparación de rentar oficinas privadas, un espacio compartido es más económico.</li>
        </ul>
        <p>Estudios recientes también muestran cómo este modelo impacta positivamente en la salud mental, reduciendo el aislamiento y generando un sentimiento de comunidad.</p>
        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.wework.com">WeWork: El futuro del trabajo</a></li>
          <li><a href="https://www.coworkingresources.org">Coworking Resources: Beneficios de coworking</a></li>
          <li><a href="https://www.forbes.com">Forbes: Impacto del coworking en empresas modernas</a></li>
        </ul>
      `,
    },
    {
      entryTitle: 'Top 5 espacios de coworking en tu ciudad',
      entryDescription:
        'Conoce los mejores espacios de coworking con instalaciones modernas, buena ubicación y ambiente profesional.',
      entryImage: 'spaces/slider2.jpg',
      entryRegDate: '20.06.24',
      longDescription: `
        <p>Explorar los mejores espacios de coworking te permite encontrar opciones que se ajusten a tu estilo de trabajo y necesidades.</p>
        <p>Aquí te presentamos los <strong>Top 5 espacios de coworking</strong> en tu ciudad, seleccionados por sus instalaciones modernas, servicios y ubicación estratégica:</p>
        <ol>
          <li><strong>HubWork Central:</strong> Ofrece salas de reuniones, internet de alta velocidad y áreas de descanso.</li>
          <li><strong>SpaceFlex:</strong> Ideal para freelancers, con planes económicos y opciones 24/7.</li>
          <li><strong>WorkHive:</strong> Cuenta con servicios premium como cabinas privadas y gimnasio incluido.</li>
          <li><strong>CollaborateHub:</strong> Espacio moderno que incentiva la creatividad con diseños innovadores.</li>
          <li><strong>OpenDesk Loft:</strong> Perfecto para equipos pequeños y startups en crecimiento.</li>
        </ol>
        <p>Al elegir un coworking, evalúa aspectos como la accesibilidad, el ambiente profesional y los servicios que ofrecen.</p>
        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.coworking.com">Coworking.com: Directorio de espacios</a></li>
          <li><a href="https://www.thehive.com">The Hive: Espacios innovadores</a></li>
          <li><a href="https://www.remote.co">Remote.co: Mejores coworkings del mundo</a></li>
        </ul>
      `,
    },
    {
      entryTitle: 'Coworking vs Trabajo Remoto: ¿Cuál es la mejor opción?',
      entryDescription:
        'Analizamos las diferencias entre trabajar desde casa y hacerlo en un espacio de coworking para optimizar tu rendimiento laboral.',
      entryImage: 'spaces/slider3.jpg',
      entryRegDate: '25.06.24',
      longDescription: `
        <p>En el debate entre <strong>trabajo remoto</strong> y <strong>espacios de coworking</strong>, cada opción tiene ventajas y desventajas.</p>
        <h5>Trabajo Remoto</h5>
        <p>Trabajar desde casa es cómodo y económico, pero puede generar <em>aislamiento</em> y menor productividad debido a las distracciones del hogar.</p>
        <h5>Espacios de Coworking</h5>
        <p>Los coworkings ofrecen:</p>
        <ul>
          <li>Un <strong>ambiente profesional</strong> que mejora el enfoque.</li>
          <li>Posibilidades de <strong>networking</strong> con otros profesionales.</li>
          <li>Instalaciones como internet de alta velocidad y salas de reuniones.</li>
        </ul>
        <p>La mejor opción dependerá de tus necesidades y estilo de trabajo. Si buscas productividad y colaboración, un coworking es ideal.</p>
        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.cnbc.com">CNBC: Coworking frente al teletrabajo</a></li>
          <li><a href="https://www.bbc.com">BBC: ¿Espacios de coworking o casa?</a></li>
          <li><a href="https://www.fastcompany.com">FastCompany: Eficiencia en coworking</a></li>
        </ul>
      `,
    },
  ];
*/

  const spacesCatEntriesData = [
    {
      post_id: '7',
      post_keywords:
        'Prestaciones Flexibles, Trabajo Híbrido, Bienestar Laboral, Retención de Talento, Flexibilidad Laboral, Modelos Híbridos, Recursos Humanos, Employer Branding, Beneficios Laborales, Cultura Organizacional, Teletrabajo, Salud y Bienestar, Transformación Digital, Gestión del Talento',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      entryTitle: 'Las prestaciones flexibles son clave para retener talento en modelos híbridos.',
      post_detail:
        '¿Tu empresa ya ofrece este tipo de prestaciones? Descubre cómo el #TrabajoHíbrido y el #BienestarLaboral pueden mejorar la #RetenciónDeTalento en tu organización.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4D22AQFsxxtdk_fWTw/feedshare-shrink_2048_1536/B4DZPW9f3CHcAs-/0/1734478267139?e=1746662400&v=beta&t=1_m53QQFnFxvtf-eF40WGOwCTjrhr4wk8-tiZDgWkOw',
      post_date: '03.01.25',
      longDescription: `
        <p>En el debate entre <strong>trabajo remoto</strong> y <strong>espacios de coworking</strong>, cada opción tiene ventajas y desventajas.</p>
        <h5>Trabajo Remoto</h5>
        <p>Trabajar desde casa es cómodo y económico, pero puede generar <em>aislamiento</em> y menor productividad debido a las distracciones del hogar.</p>
        <h5>Espacios de Coworking</h5>
        <p>Los coworkings ofrecen:</p>
        <ul>
          <li>Un <strong>ambiente profesional</strong> que mejora el enfoque.</li>
          <li>Posibilidades de <strong>networking</strong> con otros profesionales.</li>
          <li>Instalaciones como internet de alta velocidad y salas de reuniones.</li>
        </ul>
        <p>La mejor opción dependerá de tus necesidades y estilo de trabajo. Si buscas productividad y colaboración, un coworking es ideal.</p>
        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.cnbc.com">CNBC: Coworking frente al teletrabajo</a></li>
          <li><a href="https://www.bbc.com">BBC: ¿Espacios de coworking o casa?</a></li>
          <li><a href="https://www.fastcompany.com">FastCompany: Eficiencia en coworking</a></li>
        </ul>
      `,
    },
    {
      post_id: '8',
      post_keywords:
        'Querétaro, trabajo, espacio profesional, reserva on demand, reuniones, trabajo remoto, comodidad, privacidad, ambiente inspirador, espacio de trabajo, oficina profesional.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      entryTitle: '¿Viajas a Querétaro por trabajo? Reserva este lugar On Demand',
      post_detail:
        'Entra a la web y agenda en minutos. Si necesitas un espacio profesional para trabajar o realizar una reunión en Querétaro, descubre este lugar, un espacio diseñado para ofrecer comodidad, privacidad y un ambiente inspirador.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQEqjKWop63dAQ/feedshare-shrink_1280/feedshare-shrink_1280/0/1732755674508?e=1746662400&v=beta&t=b0z8Rul3bgvaFh_2ADUA9-MytDBVwuE7qPCusXDbZ0s',
      post_date: '03.12.24',
      longDescription: `
      <p>Si viajas a <strong>Querétaro</strong> por trabajo y necesitas un espacio profesional para trabajar o realizar una reunión, Popnest te ofrece la opción ideal.</p>
<h5>Beneficios del espacio Popnest:</h5>
<ul>
  <li><strong>Comodidad:</strong> Un entorno diseñado para maximizar la productividad y el confort.</li>
  <li><strong>Privacidad:</strong> Espacios que garantizan confidencialidad durante tus reuniones o trabajo personal.</li>
  <li><strong>Ambiente inspirador:</strong> Rodeado de profesionales que comparten el mismo enfoque y energía positiva.</li>
</ul>
<p>Entra a la web y agenda en minutos. Si buscas un espacio flexible y funcional, Popnest es la opción perfecta para optimizar tu tiempo de trabajo en Querétaro.</p>
<h4>Reservar espacio</h4>
<ul>
  <li><a href="https://www.popnest.com">Popnest - Reserva tu espacio</a></li>
</ul>

      `,
    },
    {
      post_id: '9',
      post_keywords:
        'Aplicaciones de productividad, Herramientas de productividad, Toma de notas, Tableros Kanban, Colaboración en equipo, Automatización de tareas, Integración con Google Drive, Integración con Slack, Aplicaciones móviles, Plantillas prediseñadas, Gestión de bases de datos, Soporte al cliente, Aplicaciones para productividad personal.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      entryTitle:
        'Recomendaciones de aplicaciones de productividad y sus principales características',
      post_detail:
        'Descubre las mejores aplicaciones de productividad, con características como toma de notas, tableros Kanban, colaboración en equipo, automatizaciones, integraciones con Google Drive y Slack, aplicaciones móviles, plantillas prediseñadas, uso intuitivo, gestión de bases de datos y soporte al cliente.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQESQwGxdUON7w/feedshare-shrink_800/feedshare-shrink_800/0/1732599696034?e=1746662400&v=beta&t=ZOR0yGTlyPG4JZe2ImnVU_BDduNw4err6UNM8Wqq_EU',
      post_date: '22.06.24',
      longDescription: `
       <p>Las aplicaciones de productividad se han convertido en herramientas esenciales para mejorar la eficiencia y la organización tanto en el trabajo como en la vida personal. Existen múltiples opciones que ofrecen funcionalidades como la toma de notas, la creación de tableros Kanban, y la colaboración en equipo. Estas aplicaciones permiten automatizar tareas, integrar servicios como Google Drive y Slack, y contar con aplicaciones móviles que facilitan el acceso a la información desde cualquier lugar.</p> <p>Además, muchas de estas herramientas incluyen plantillas prediseñadas que simplifican el proceso de organización, así como opciones de gestión de bases de datos para estructurar y analizar información. Con un uso intuitivo y soporte al cliente de calidad, estas aplicaciones de productividad se adaptan a las necesidades de usuarios individuales y equipos de trabajo, optimizando los flujos de trabajo y mejorando la colaboración.</p> <h4>Referencias:</h4> <ul> <li><a href="https://www.todoist.com">Todoist: Herramienta de productividad para gestión de tareas</a></li> <li><a href="https://www.trello.com">Trello: Tableros Kanban y gestión de proyectos</a></li> <li><a href="https://www.notion.so">Notion: Aplicación todo-en-uno para productividad</a></li> <li><a href="https://www.slack.com">Slack: Comunicación y colaboración de equipo</a></li> </ul>
      `,
    },
  ];


  return (
    <FlexContainer className={'flex-column padlr120 m-padlr20 bgWhite'}>
      {customTitle && (
        <Label type="Subtitle-1 text-20 bold padtb20 m-margtb20 padlr20 m-padlr0 fontGray250 text-center">
          {customTitle}
        </Label>
      )}
      <EntriesRow entriesData={spacesCatEntriesData} setDetailEntryData={setDetailEntryData} />
    </FlexContainer>
  );
};

export default BlogModule;
